import { Flex, Link } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { useContentAsset } from '../../../../../../bff-api/content/useContentAsset';
import { Text } from '../../../../../../ui-components';
import { ContentAssetID } from '../../../../../../utils/api/ContentAssetID';
import { sanitizeHtml } from '../../../../../content-asset/sanitize-html';
import { ArrowRightIcon } from '../../../../../icons';
import styles from '../MenuCategoryDesktop.module.scss';
import type { Category } from '../../../../../../bff-api/categories/model/category';

export const MenuCategoryBrandsDesktop: React.FC<{
    brands: Category;
}> = ({ brands }) => {
    const { data: brandsAE } = useContentAsset(ContentAssetID.BRANDS_A_E);
    const { data: brandsFJ } = useContentAsset(ContentAssetID.BRANDS_F_J);
    const { data: brandsKO } = useContentAsset(ContentAssetID.BRANDS_K_O);
    const { data: brandsPT } = useContentAsset(ContentAssetID.BRANDS_P_T);
    const { data: brandsU123 } = useContentAsset(ContentAssetID.BRANDS_U_123);

    return (
        <Flex
            data-testid="header.menu.desktop.category.brands.content"
            gap={8}
            height="fit-content"
        >
            <Flex direction="column" grow={1} gap={8} className={styles.menu_brands}>
                <Flex columnGap={8}>
                    {brandsAE?.html ? (
                        <Flex
                            data-testid="header.menu.desktop.category.brands.a_e"
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(brandsAE.html),
                            }}
                        />
                    ) : null}

                    {brandsFJ?.html ? (
                        <Flex
                            data-testid="header.menu.desktop.category.brands.f_j"
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(brandsFJ.html),
                            }}
                        />
                    ) : null}
                </Flex>

                <Flex columnGap={8}>
                    {brandsKO?.html ? (
                        <Flex
                            data-testid="header.menu.desktop.category.brands.k_o"
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(brandsKO.html),
                            }}
                        />
                    ) : null}

                    {brandsPT?.html ? (
                        <Flex
                            data-testid="header.menu.desktop.category.brands.p_t"
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(brandsPT.html),
                            }}
                        />
                    ) : null}
                </Flex>

                {brandsU123?.html ? (
                    <Flex
                        data-testid="header.menu.desktop.category.brands.u_123"
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHtml(brandsU123.html),
                        }}
                    />
                ) : null}
            </Flex>

            <Flex direction="column" justifyContent="space-between" width="20%">
                {brands.headerMenuBanner1 ? (
                    <Flex
                        data-testid="header.menu.desktop.category.brands.banner1"
                        direction="column"
                        rowGap={4}
                        maxWidth="248px"
                        textStyle="body-base"
                        className={styles.menu_banner}
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHtml(brands.headerMenuBanner1),
                        }}
                    />
                ) : null}

                {brands.showShopAllLink ? (
                    <Link data-testid="header.menu.desktop.category.brands.link" href={brands.url}>
                        <Flex
                            grow={1}
                            shrink={0}
                            gap={2}
                            alignItems="center"
                            justifyContent="flex-end"
                        >
                            <Text size="small" style="bolder">
                                <FormattedMessage
                                    id="header.see.all.featured"
                                    defaultMessage="See All Featured {category}"
                                    values={{
                                        category: brands.displayName,
                                    }}
                                />
                            </Text>
                            <ArrowRightIcon marginBottom={0.5} />
                        </Flex>
                    </Link>
                ) : null}
            </Flex>
        </Flex>
    );
};
